// extracted by mini-css-extract-plugin
export default {"recos":"K6-z","productCardOverride":"L6-z","rowHasBadge":"M6-z"};